// extracted by mini-css-extract-plugin
module.exports = {"container":"Docs_container___P1Rw","title":"Docs_title__D82Si","tableContainer":"Docs_tableContainer__pUvfd","noItems":"Docs_noItems__7PFHL"};